import AxiosService from './AxiosService';

export default class General {
    contactForm(data, onSuccess, onError) {
        AxiosService('post', '/contact', data, onSuccess, onError);
    }
}
